import HistoryCoin from './HistoryCoin.container';

export default HistoryCoin;
